module.exports = __webpack_public_path__ + "assets/img/btn-download-hover-0e8f1c84.png";